import React, { Component } from 'react'
import styled from 'styled-components';
import AboutSection from "./../home/AboutSection";
import AboutSection2 from "./../home/AboutSection2";
import RegisterSection from "./../home/RegisterSection";
import Grid from '@material-ui/core/Grid';
import SectionLineTitle from './../../../shared/components/SectionLineTitle';
import SectionRowLayout from './../../../shared/components/SectionRowLayout';
import DynamicElement from 'shared/components/DynamicElement';
import {
    withWidth,
} from "@material-ui/core";
import MapSection from "./../../components/home/MapSection";
import classNames from 'classnames';

const Wrapper = styled.div`
background-color: #121416;
background-image: url(/images/Group-7352.png);
position: relative;

@media (max-width: 600px){
    .register-wrapper{
        padding-bottom: 50px !important;
    }
}
`;

const ThirdSection = styled.div`
background: white;
font-size: 0; /* this is to remove gap between layers  */ 

@media (max-width: 600px){
    .MuiGrid-root{ 
        flex-direction: column;
    }
    .MuiGrid-item{ 
        max-width: 100%;
        padding: 0px 30px 0px 30px !important;
    }

    .SectionLineTitleWrap{
        display: block;
        text-align: right;

        h3{
            display: inline;
            text-align: left;
        }
        div{
            display: inline;
            text-align: left;
        }
    }

    .MainText{
        font-size: 55px;
        line-height: 1;
        text-align: center;
        line-height: 1;
        display: block;
        margin-bottom: 20px;
    }

    .content{
        text-align: center;
        display: block;
    }
}
`;



const Heading = styled.h1`
font-family: MinionPro-Disp;
font-size: 100px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: 0;
letter-spacing: normal;
text-align: center;
color: #313438;
margin-top: 45px;

@media (max-width: 600px){
  margin: 30px 74px 0 75px;
  font-family: MinionPro-Disp;
  font-size: 55px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0;
  letter-spacing: normal;
  text-align: center;
  color: #313438;
}
`;

const AboutHenigQuote = styled.div`
max-width: 422px;
font-family: Lato;
font-size: 16px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: 1.88;
letter-spacing: normal;
text-align: left;
color: #b6b8bc;

@media (max-width: 600px){
  margin: 24px 25px 0;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: center;
  color: #b6b8bc;
}
`;

class AboutUs extends Component {

    componentDidMount() {
        const { selectAboutUs = () => { } } = this.props;
        selectAboutUs();
    }

    render() {
        const { openPasswordDialog, openLoginDialog, width } = this.props;
        console.log(width)
        return (
            <Wrapper>
                <div className="lg-p-top">
                    <Heading>
                        <DynamicElement id="5ff7a3beabbee9b8a71dece0">
                            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                        </DynamicElement>
                    </Heading>
                    <Grid container style={{ margin: width === 'xs' ? 'none' : '0 auto', paddingBottom: 120, paddingTop: 25 }} spacing={8} justify="center">
                        <Grid item>
                            <DynamicElement id="5ff7a430abbee9b8a71dece1">
                                {({ value }) => <img style={{ maxWidth: 438 }} src={value} />}
                            </DynamicElement>
                        </Grid>
                        <Grid item style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            <SectionLineTitle size="big" style={width === 'xs' ? { marginBottom: 25, float: 'right', marginRight: 35 } : { marginBottom: 25 }}>
                                <DynamicElement id="5ff7a482abbee9b8a71dece2">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </SectionLineTitle>
                            <AboutHenigQuote>
                                <DynamicElement id="5ff7a4aaabbee9b8a71dece3">
                                    {({ value }) => <span>“<span dangerouslySetInnerHTML={{ __html: value }} />”</span>}
                                </DynamicElement>
                            </AboutHenigQuote>
                        </Grid>
                    </Grid>
                </div>

                <AboutSection
                    id={'about-us'}
                    bigImage="601600502f68b1f4b1b90cc1"
                    smallTitle="6016013b2f68b1f4b1b90cc2"
                    bigTitle="6016016e2f68b1f4b1b90cc3"
                    description="601601f22f68b1f4b1b90cc4"
                    smallImage="601602142f68b1f4b1b90cc5"
                    noHeightStretch
                />
                <AboutSection2
                    id={'about-us-2'}
                    bigImage="6016026a2f68b1f4b1b90cc6"
                    bigImage2="6016028c2f68b1f4b1b90cc7"
                    bigImage3="601602af2f68b1f4b1b90cc8"
                    smallTitle="601602d72f68b1f4b1b90cc9"
                    bigTitle="601603072f68b1f4b1b90cca"
                    description="601603282f68b1f4b1b90ccb"
                    noHeightStretch
                />

                <ThirdSection className={width !== 'xs' && "lg-p-top"}>

                    <SectionRowLayout
                        swapSides
                        infoSize={6}
                        bigImageSize={6}
                        infoSideStyle={{ paddingBottom: 0 }}
                        bigImage={'5ff7a626abbee9b8a71dece7'}
                        sectionLineTitleStyle={{ marginTop: 10 }}
                        smallTitle={<div>
                            <DynamicElement id="5ff7a542abbee9b8a71dece4">
                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </div>}
                        bigTitle={<div style={{ marginTop: 45 }}>
                            <DynamicElement id="5ff7a581abbee9b8a71dece5">
                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </div>}
                        description={<div style={{ maxWidth: 422 }}>
                            <DynamicElement id="5ff7a5d1abbee9b8a71dece6">
                                {({ value }) => <span className="content" dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </div>}
                    />

                    <SectionRowLayout
                        swapSides={width === 'xs'}
                        infoSize={6}
                        bigImageSize={6}
                        bigImageSideStyle={{ paddingTop: 0 }}
                        bigImage={'5ff83ea1abbee9b8a71decf4'}
                        sectionLineTitleStyle={{ marginTop: 84 }}
                        smallTitle={<div>
                            <DynamicElement id="5ff7a788abbee9b8a71dece9">
                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </div>}
                        bigTitle={<div style={{ marginTop: 15 }}>
                            <DynamicElement id="5ff7a754abbee9b8a71dece8">
                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </div>}
                        description={<p style={{ maxWidth: 422 }}>
                            <DynamicElement id="5ff7a7c4abbee9b8a71decea">
                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </p>}
                    />

                    <div className={`${width !== 'xs' && 'container-fluid'} lg-p-top`}>
                        <SectionRowLayout
                            swapSides
                            infoSize={6}
                            bigImageSize={6}
                            infoSideStyle={{ paddingBottom: 0, paddingLeft: 0, paddingRight: 88 }}
                            bigImage={'5ff7a892abbee9b8a71deceb'}
                            bigImageSideStyle={{ paddingTop: 115 }}
                            sectionLineTitleStyle={{ marginTop: 10 }}
                            smallTitle={<div>
                                <DynamicElement id="5ff7a8afabbee9b8a71decec">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </div>}
                            bigTitle={<div style={{ marginTop: 45 }}>
                                <DynamicElement id="5ff7a8c8abbee9b8a71deced">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </div>}
                            description={<div style={{ maxWidth: 422, marginTop: 25 }}>
                                <DynamicElement id="5ff7a8e2abbee9b8a71decee">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </div>}
                        />
                    </div>

                    <div className={classNames("lg-p-bottom", "register-wrapper")}>
                        <RegisterSection
                            id={'register'}
                            noHeightStretch
                            onSubmitComplete={(values, userExists) => {
                                if (userExists) {
                                    openLoginDialog({ initialValues: values })
                                } else {
                                    openPasswordDialog({ initialValues: values })
                                }
                            }}
                        />
                    </div>
                </ThirdSection>

                <MapSection />
            </Wrapper>
        )
    }
}

export default withWidth()(AboutUs);